import React from 'react';
import '../../styles/HLine.css';

export default function HLine() {
    return <div className="h-line"></div>
}
